module.exports = __webpack_public_path__ + "img/document-preview.75d3a6f.png";